import { Badge  } from "@mantine/core";
import { Link } from "wouter";
import { IconSparkles, IconStar, IconStars } from "@tabler/icons-react";

function colorForPlan(plan) {
  switch(plan) {
    case "Pro": return "orange";
    case "Premium": return "grape";
    case "Basic": return "myColor";
    case "Free":
    default: return "gray";
  }
}

function sizeForSize(size) {
  switch(size) {
    case "sm": return 12;
    case "md": return 14;
    case "lg": return 20;
    default: return 14;
  }
}

function iconForPlan(plan, badgeSize) {
  const size = sizeForSize(badgeSize);
  switch(plan) {
    case "Pro": return <IconStars size={size} />
    case "Premium": return <IconSparkles size={size} />;
    case "Basic": return <IconStar size={size} />
    case "Free": 
    default: return null;
  }
}

export default function PlanBadge({ plan, size, ...props }) {
  let color = colorForPlan(plan);
  return (<Badge leftSection={iconForPlan(plan, size)} size={size} color={color} component={Link} href="/profile" style={{ cursor: "pointer" }} {...props}>{plan}</Badge>)
}
